import { createStore } from 'vuex';
import { setAuthToken, resetAuthToken } from './configs/headers';
import createPersistedState from "vuex-persistedstate";

const store = createStore({
    plugins: [createPersistedState()],
    state() {
        return {
            loader: false,
            brand_settings: [],
            brand_skins: [],
            permissions: [],
            role: '',
            remember_role: '',
            integrations: [],
            is_customer: false,
            brand: [],
            user: {
                bearerToken: null,
                isAuthenticated: false
            },
            reorderCustomerId: '',
            customerId: '',
            routeFrom:'',
            shopCustomerId:'',
            cartProducts:[],
            signUpDocFile: null,
            orderDetailModalOpen : false,
            openChats: [], // array of { id, name, initials, ... }
            // Email limit state
            emailCount: 0,
            emailLimit: 500,
            isEmailLimitReached: false,
            oauth_redirect: null,
        };
    },
    // persist: true,
    getters: {
        brand_settings(state) {
            return state.brand_settings;
        },
        brand_skins(state) {
            return state.brand_skins;
        },
        permissions(state) {
            return state.permissions;
        },
        role(state) {
            return state.role;
        },
        integrations(state) {
            return state.integrations;
        },
        brand(state) {
            return state.brand;
        },
        user(state) {
            return state.user;
        },
        openChats: (state) => state.openChats,
        shopCustomerId: (state) => state.shopCustomerId,
        // Email getters
        emailCount: (state) => state.emailCount,
        emailLimit: (state) => state.emailLimit,
        isEmailLimitReached: (state) => state.isEmailLimitReached,
    },
    mutations: {
        SHOW_LOADER(state, data) {
            state.loader = data;
        },
        SET_BRAND_SETTINGS_LIST(state, data) {
            if (data && data.default_page_size !== undefined) {
            data.default_page_size = parseInt(data.default_page_size, 10);
            }
            state.brand_settings = data;
        },
        SET_BRAND_SKIN_LIST(state, data) {
            state.brand_skins = data;
        },
        SET_PERMISSIONS(state, data) {
            state.permissions = data;
        },
        SET_ROLE(state, data) {
            state.role = data;
        },
        REMEMBER_ROLE(state, data) {
            state.remember_role = data;
        },
        SET_INTEGRATIONS(state, data) {
            state.integrations = data;
        },
        IS_CUSTOMER(state, data) {
            state.is_customer = data;
        },
        SET_BRAND(state, data) {
            state.brand = data;
            if (data && data.brand_name) {
                document.title = data.brand_name;
            }
        },
        SET_USER(state, data) {
            state.user = {
                bearerToken: data.token,
                user: data.user,
                isAuthenticated: true
            };
        },
        RESET_USER(state) {
        (state.user = {
            bearerToken: null,
            user: null,
            isAuthenticated: false
        }),
         (state.brand_skins = [],state.permissions = [],state.role = '',state.integrations = [],state.remember_role = '',
            state.is_customer = '',state.brand = {},state.brand_settings = {},state.cartProducts=[]);
        },
        SET_BRAND_LOGIN_BANNER(state, data) {
            state.brand.brand_login_banner = data;
        },
        SET_BRAND_LOGO(state, data) {
            state.brand.brand_logo = data;
        },
        SET_BRAND_NAME(state, data){
            state.brand.brand_name = data
            if (data) {
                document.title = data;
            }
        },
        SET_BRAND_FAVICON(state, data){
            state.brand.brand_favicon = data
        },
        SET_REORDER_CUSTOMER_ID(state, data) {
            state.reorderCustomerId = data;
        },
        SET_CUSTOMER_ID(state, data) {
            state.customerId = data;
        },
        SET_FROM_ROUTE(state,data){
            state.routeFrom=data
        },
        SET_BRAND_NAME(state, data){
            state.brand.brand_name = data
        },
        SET_SHOP_CUSTOMER_ID(state, data){
            state.shopCustomerId=data;
        },
        SET_CART_PRODUCTS(state,data){
            state.cartProducts=data
        },
        SET_SIGN_UP_DOC_FILE(state, file) {
            state.signUpDocFile = file;
        },
        OPEN_ORDER_DETAIL_MODAL(state, payload) {
            state.orderDetailModalOpen = payload;
        },
        OPEN_CHAT(state, user) {
            const exists = state.openChats.find((u) => (u.id === user.id && u.type === user.type));
            if (!exists) state.openChats.push(user);
        },
        CLOSE_CHAT(state, user) {
            state.openChats = state.openChats.filter((u) => !(u.id === user.id && u.type === user.type));
        },
        // Email mutations
        SET_EMAIL_LIMIT_DATA(state, payload) {
            if (typeof payload.emailCount === 'number') state.emailCount = payload.emailCount;
            if (typeof payload.emailLimit === 'number') state.emailLimit = payload.emailLimit;
            if (typeof payload.isEmailLimitReached === 'boolean') state.isEmailLimitReached = payload.isEmailLimitReached;
        },
        UPDATE_EMAIL_LIMIT_STATUS(state, status) {
            state.isEmailLimitReached = !!status;
        },
         SET_SHIPSTATION_CONNECTED(state, data) {
            state.brand.isShipstationConnected = data;
        },
        SET_OAUTH_REDIRECT(state, url) {
            state.oauth_redirect = url;
        },
        CLEAR_OAUTH_REDIRECT(state) {
            state.oauth_redirect = null;
        }
    },
    
    actions: {
        async getData({ commit }, data) {
            if (data) {
                commit("SET_USER", data);
                if (data.user_role !== '') {
                    commit('SET_ROLE', data.user_role);
                }
                setAuthToken(data.token);
                localStorage.setItem("access-token", data.token);
            }
        },
        async reset({ commit }) {
            commit("RESET_USER");
            resetAuthToken();
            localStorage.removeItem("access-token");
            localStorage.removeItem("vuex");
        },
        openChat({ commit }, user) {
            commit('OPEN_CHAT', user);
        },
        closeChat({ commit }, user) {
            commit('CLOSE_CHAT', user);
        }
    }
});

// if (process.browser) {
//     const token = localStorage.getItem("access-token");
//     if (token) {
//         setAuthToken(token);
//     } else {
//         resetAuthToken();
//     }
// }

export default store;
